/* Per-language photo swap. window.__locMedia = { "base.jpg": { "pl": "//cdn/.../base-pl.jpg", ... } } */
(function () {
  function lang() {
    var l = (window.PDP_I18N && window.PDP_I18N.language) || document.documentElement.lang || 'en';
    l = String(l).toLowerCase(); if (l === 'no' || l === 'nn') l = 'nb'; return l.split('-')[0];
  }
  function apply() {
    var map = window.__locMedia || {}, l = lang();
    document.querySelectorAll('img').forEach(function (img) {
      var orig = img.getAttribute('data-loc-orig') || img.getAttribute('src') || '';
      var file = orig.split('?')[0].split('/').pop();
      var m = map[file]; if (!m) return;
      if (!img.hasAttribute('data-loc-orig')) img.setAttribute('data-loc-orig', orig);
      var want = m[l] || orig;
      if (img.getAttribute('src') !== want) { img.setAttribute('src', want); img.removeAttribute('srcset'); }
    });
  }
  document.addEventListener('pdp:language-change', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply);
})();
